export const GUEST_EMAIL_OTP = "GUEST_EMAIL_OTP";
export const GUEST_EMAIL_OTP_ERROR = "GUEST_EMAIL_OTP_ERROR";
export const GUEST_EMAIL_OTP_HIDE_ERROR = "GUEST_EMAIL_OTP_HIDE_ERROR";
export const GUEST_EMAIL_OTP_START_LOADER = "GUEST_EMAIL_OTP_START_LOADER";
export const GUEST_EMAIL_OTP_STOP_LOADER = "GUEST_EMAIL_OTP_STOP_LOADER";
